import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import {
  type GroupType,
  type DeleteCostOffsetCodeMutation,
  type DeleteCostOffsetCodeMutationVariables,
} from 'graphql-query-contracts';
import { deleteCostOffsetCodeMutation } from 'graphql-queries';

export interface DeleteCostOffsetCodeInput {
  id: string;
  groupId: string;
  groupType: GroupType;
}

export interface UseDeleteCostOffsetCodeResult {
  deleteCostOffsetCode: (input: DeleteCostOffsetCodeInput) => Promise<void>;
  loading: boolean;
  error: Error | undefined;
}

export function useDeleteCostOffsetCode(): UseDeleteCostOffsetCodeResult {
  const [mutate, { loading, error }] = useMutation<
    DeleteCostOffsetCodeMutation,
    DeleteCostOffsetCodeMutationVariables
  >(deleteCostOffsetCodeMutation);

  const deleteCostOffsetCode = useCallback(
    async (input: DeleteCostOffsetCodeInput): Promise<void> => {
      await mutate({
        variables: {
          deleteCostOffsetCodeRequest: {
            id: input.id,
            groupId: input.groupId,
            groupType: input.groupType,
          },
        },
      });
    },
    [mutate]
  );

  return {
    deleteCostOffsetCode,
    loading,
    error: error ?? undefined,
  };
}
